import { Pipe, PipeTransform } from "@angular/core";
import { getOrdinalDate, toDate } from "src/app/shared/utils/date.util";

@Pipe({
	name: "ordinalDate",
	pure: true
})
export class OrdinalDatePipe implements PipeTransform {
	/**
	 * Transforms a Date-like input into an ordinal date string, e.g., "8th December 2025".
	 * Accepts Date | string.
	 */
	transform(value: Date | string): string {
		if (value == null) return "";

		const date = toDate(value);
		if (Number.isNaN(date.getTime())) return "";

		// Pass a Date directly—avoid locale-dependent intermediate strings.
		return getOrdinalDate(date);
	}
}
